import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { urls } from 'features/common/fetch/constants';
import { fetchLeadDetails } from 'features/views/leadDetail/actions';
import { feedbackType } from 'features/views/marketPlace/constants';
import LeadFeedback from 'pages/MarketPlace/components/LeadFeedback';

export const LeadDetailFeedback = ({ lead }) => {
	const dispatch = useDispatch();

	const handleReloadLeadDetail = useCallback(() => {
		dispatch(fetchLeadDetails(lead?.id));
	}, [dispatch, lead?.id]);

	return (
		<ComponentLoader fetchStorePath={urls.leadDetail} onReload={handleReloadLeadDetail} ignoreErrors>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('leadDetail:leadDetailFeedback')} />
				<LeadFeedback lead={lead} type={feedbackType.IN_DETAIL} />
			</Stack>
		</ComponentLoader>
	);
};

LeadDetailFeedback.propTypes = {
	lead: PropTypes.object,
};

export default LeadDetailFeedback;
